export default "__VITE_ASSET__0a138bb4__"